// gtm
export const ABANDONED_RETURNED_TO_CART = 'abandoned_returned_to_cart';
export const ADD_TO_CART = 'add_to_cart';
export const LINK_CLICK = 'link_click';
export const LOGIN = 'login';
export const MENU_CLICK = 'menu_click';
export const OPEN_CART = 'open_cart';
export const OPEN_DISCOUNT_DRAWER = 'open_discount_drawer';
export const REMOVE_FROM_CART = 'remove_from_cart';
export const SEARCH = 'search';
export const SET_DATA = 'set_data';
export const SIGN_UP = 'sign_up';
export const VIRTUAL_PAGE_VIEW = 'virtual_page_view';
